import { render } from "./productsPatternSummary.vue?vue&type=template&id=547f988c&scoped=true"
import script from "./productsPatternSummary.vue?vue&type=script&lang=js"
export * from "./productsPatternSummary.vue?vue&type=script&lang=js"

import "./productsPatternSummary.vue?vue&type=style&index=0&id=547f988c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547f988c"]])

export default __exports__